import { useContext, createContext } from "react";

import { PaidJiraPageType } from "@/utils/paid-page-types";

type PaidJswProductTourContextType = {
    isLoggedIn: boolean;
    paidJiraPageType: PaidJiraPageType;
};

const defaultValues = {
    isLoggedIn: false,
    paidJiraPageType: PaidJiraPageType.DEFAULT
};

export const PaidJswProductTourContext =
    createContext<PaidJswProductTourContextType>(defaultValues);

export const usePaidJswProductTourContext = () => {
    const { isLoggedIn, paidJiraPageType } = useContext(
        PaidJswProductTourContext
    );

    // if user is logged out and page paid-lp-jsw-features page show animated hero
    const isAnimatedHero =
        !isLoggedIn &&
        paidJiraPageType === PaidJiraPageType.PAID_LP_JSW_FEATURES;
    return { isLoggedIn, paidJiraPageType, isAnimatedHero };
};
